import { IconSvgProps } from '../types';

export const Book = ({ size }: IconSvgProps) => (
  <svg
    id="icon-object-book"
    width={size}
    height={size}
    viewBox="0 0 52 65"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g fill="currentColor">
        <path d="M51.71,44.99 L51.71,4.6 C51.71,2.54 50.04,0.88 47.98,0.88 L10.08,0.88 C4.59,0.88 0.14,5.33 0.14,10.82 L0.14,54.93 C0.14,57.85 1.39,60.47 3.4,62.29 C1.39,60.47 0.14,57.85 0.14,54.93 C0.14,49.44 4.59,44.99 10.08,44.99 L51.71,44.99 Z" />
        <path
          d="M51.71,52.14 L51.71,44.99 L10.08,44.99 C4.59,44.99 0.14,49.44 0.14,54.93 C0.14,60.42 4.59,64.87 10.08,64.87 L47.98,64.87 C50.04,64.87 51.71,63.2 51.71,61.15 L51.71,57.73 L51.71,57.73 L12.82,57.73 C11.27,57.73 10.02,56.48 10.02,54.93 C10.02,53.43 11.2,52.21 12.68,52.14 L12.82,52.14 L51.71,52.14 C51.71,52.14 51.71,52.14 51.71,52.14 Z"
          opacity="0.5"
        />
      </g>
    </g>
  </svg>
);
